import axios from './createAxiosInstalce';

/*
    请求预处理
*/

export default function createRequest(apiOption = { url: '', method: 'get' }) {
  const option = apiOption;
  option.config = apiOption.config || {};
  const getRequest = {
    post: (url, payload, config) => axios.post(url, payload, { ...option.config, ...config }),
    put: (url, payload, config) => axios.put(url, payload, { ...option.config, ...config }),
    get: (url, payload, config) => axios.get(url, { params: payload, ...config }),
    delete: (url, payload, config) => axios.delete(url, { ...option.config, ...config })
  };
  const catchFn = () => {
    console.error('请求方式不存在', apiOption);
    return Promise.reject();
  };
  const request = getRequest[option.method] || catchFn;
  return (params, config) => {
    const requestUrl = typeof apiOption.url === 'function' ? apiOption.url(params) : apiOption.url;
    return request(requestUrl, params, config).then((data) => data.data);
  };
}
